import styled from 'styled-components';
import { Flex, unitizedPx } from '@badi/badi-components';

export const Root = styled(Flex)`
  width: ${unitizedPx(55)};
  max-width: 100%;
`;
